import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AplicativoDTO } from '@app/proyecto/dto/AplicativoDTO';
import { ApiService } from '@app/proyecto/services/api.service';

@Component({
  selector: 'app-aplicativos',
  templateUrl: './aplicativos.component.html',
  styleUrls: ['./aplicativos.component.css']
})
export class AplicativosComponent implements OnInit {

  idApp: number=0
  apps: AplicativoDTO[]=[]
  link:string=""
  timestamp:string=Date.now().toString()
  
  constructor(private sanitizer:DomSanitizer,private route: ActivatedRoute,private apiService: ApiService,private router: Router) { }

  ngOnInit(): void {
    this.apiService.ObtenerApps().subscribe(res=>{
      this.apps=res
      
      this.route.paramMap.subscribe(
        (params: Params) => {
          this.idApp = +params['params'].id
          if(this.idApp) this.apps=this.apps.filter(a=>a.id==this.idApp)
        })  
    })
  }
  
  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
  
  instalarIOS(url:string){
    this.link="https://google.cl"
    let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
    
    element.click();
  }
}
